const INITIAL_STATE = {
  data: {},
  didInvalidate: false,
  fetchingInProgressSince: null,
  lastSuccessfulFetch: null,
  lastFailedFetch: null,
  lastErrorMessage: null,
  consentedAt: null,
  consentConsumed: false,
  legalDataUpdated: null,
};
const APPROVE_LEGAL_DATA = 'APPROVE_LEGAL_DATA';
const CONSUME_LEGAL_DATA = 'CONSUME_LEGAL_DATA';

module.exports = function LegalDataReducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case 'SET_API_URL':
      return INITIAL_STATE;
    case 'SET_LANGUAGE':
    case 'INVALIDATE_LEGAL_DATA':
      return {
        ...state,
        didInvalidate: true,
      };
    case 'FETCH_LEGAL_DATA_IN_PROGRESS': {
      return {
        ...state,
        fetchingInProgressSince: action.timestamp,
      };
    }
    case 'FETCH_LEGAL_DATA_SUCCESSFUL':
      return {
        ...state,
        didInvalidate: false,
        fetchingInProgressSince: null,
        lastSuccessfulFetch: action.timestamp,
        data: action.data,
        consentedAt:
          state.data && state.data._id === action.data._id
            ? state.consentedAt
            : null,
        legalDataUpdated: state.data?._id && state.data._id !== action.data._id,
      };
    case 'FETCH_LEGAL_DATA_FAILED':
      return {
        ...state,
        fetchingInProgressSince: null,
        lastFailedFetch: action.timestamp,
        lastErrorMessage: action.reason,
      };
    case APPROVE_LEGAL_DATA:
      return {
        ...state,
        consentedAt: new Date(),
      };
    case CONSUME_LEGAL_DATA:
      return {
        ...state,
        consentConsumed: true,
      };
    default:
      return state;
  }
};

module.exports.APPROVE_LEGAL_DATA = APPROVE_LEGAL_DATA;
module.exports.CONSUME_LEGAL_DATA = CONSUME_LEGAL_DATA;
